import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/multiLocationOverviewSaga";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";

import FilterLevelFirstSelect from "./smartComponents/filterLevelFirstSelect";
import FilterLevelSecondSelect from "./smartComponents/filterLevelSecondSelect";
import FilterLevelThirdSelect from "./smartComponents/filterLevelThirdSelect";
import FilterLevelFourSelect from "./smartComponents/filterLevelFourthSelect";
import FilterLevelFiveSelect from "./smartComponents/filterLevelFifthSelect";
import DatePicker from "./smartComponents/datePicker";
import OverviewTable from "./smartComponents/overviewTable";
import AllLocationsTable from "./smartComponents/allLocationsTable";
import CustomDateRange from "./smartComponents/customDateRange";
import LearnMore from "../../../components/learnMore/learnMore";
import "./multiLocationOverview.css.scss";
import GroupBy from "./smartComponents/groupBy";

const MultiLocationOverviewModule = (props) => {
  const dispatch = useDispatch();
  const location = useSelector(
    (state) => state.multiLocationOverview.allLocationsData.tableInfo.colHeaders[0]
  );
  const {
    isLoading,
    filtersLoading,
    filtersDirty,
    availableFilters,
    selectedLevelFirst,
    selectedLevelSecond,
    selectedLevelThird,
    selectedLevelFourth,
    selectedLevelFifth,
    secondLevelFiltersLoading,
    thirdLevelFiltersLoading,
    selectedRequestDates,
    tablesLoading,
    allLocationsTablesLoading,
    fourthLevelFiltersLoading,
    breakdownTableLabel
  } = useSelector((state) => state.multiLocationOverview);

  useEffect(() => {
    initFetchData();
  }, []);

  const resetData = () => {
    initFetchData();
  };

  const addSticky = () => {
    const stickyElm = document.getElementById("sticky-select-bar");
    if (!stickyElm) return;

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("isSticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(stickyElm);
  };

  const initFetchData = () => {
    dispatch(actionCreators.fetchOverviewData(props));
  };

  const updateTables = () => {
    dispatch(actionCreators.requestNewTableData());
  };

  const canRenderUpdateButton = () => {
    if (
      filtersDirty &
      !isLoading &
      (selectedLevelFirst.length > 0) &
      (selectedLevelSecond.length > 0) &
      (selectedLevelThird.length > 0) &
      (selectedLevelFourth.length > 0) &
      (selectedLevelFifth.length > 0) &
      (selectedRequestDates.startDate !== "Invalid date") &
      (selectedRequestDates.endDate !== "Invalid date")
    ) {
      return true;
    }

    return false;
  };

  !isLoading &&
    setTimeout(() => {
      addSticky();
    }, 1000);
  const filterLevels = availableFilters?.filter_levels;
  const filterTitles = availableFilters?.filter_titles;

  return (
    <SectionToggle
      title="Multi Location Overview"
      customClass="multi-location-overview withSticky"
      autoHeight
      hideToggle
      learnMore={<LearnMore content={content} />}
      content={
        <div className="content-wrapper">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <>
              {!filtersLoading && !isLoading && (
                <div className="edit-selections-bar" id="sticky-select-bar">
                  <div className="dates-container">
                    <div className="select-box" style={{ width: 362 }}>
                      <p className="offers-title">Date Range</p>
                      <CustomDateRange />
                    </div>
                    <div className="date-select-box multi" style={{ width: 317 }}>
                      <p>Date</p>
                      <DatePicker />
                    </div>
                  </div>
                  <div className="filters-container">
                    {filterLevels && filterLevels.includes("level_1") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[0]}</p>
                        <FilterLevelFirstSelect />
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_2") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[1]}</p>
                        {!secondLevelFiltersLoading ? (
                          <FilterLevelSecondSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_3") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[2]}</p>
                        {!thirdLevelFiltersLoading ? (
                          <FilterLevelThirdSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    {filterLevels && filterLevels.includes("level_4") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[3]}</p>
                        {!fourthLevelFiltersLoading ? (
                          <FilterLevelFourSelect />
                        ) : (
                          <LoadingAnimation uiLoader />
                        )}
                      </div>
                    )}
                    <GroupBy />
                    {filterLevels && filterLevels.includes("level_5") && (
                      <div className="select-box" style={{ width: 175 }}>
                        <p>{filterTitles[4]}</p>
                        <FilterLevelFiveSelect />
                      </div>
                    )}
                    <div className="action-buttons">
                      {canRenderUpdateButton() && (
                        <button className="submit submit-button" onClick={updateTables}>
                          Update
                        </button>
                      )}
                      {filtersDirty && (
                        <button className="submit reset reset-button" onClick={resetData}>
                          Reset
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {tablesLoading ? (
                <LoadingAnimation />
              ) : (
                <div className=".all-locations-wrapper" style={{ backgroundColor: "transparent" }}>
                  <h1>All Locations</h1>
                  <div style={{ float: "left", width: "100%" }}>
                    <OverviewTable />
                  </div>
                </div>
              )}
            </>
          )}
          <>
            {allLocationsTablesLoading ? (
              <LoadingAnimation />
            ) : (
              <div
                className={`allLocationsDataWrapper all-locations-wrapper
                     ${location !== "Location" ? "resetAlignment" : ""}
                    `}
              >
                <h1>Breakdown by {breakdownTableLabel}</h1>
                <div className="allLocationsTableWrapper">
                  <AllLocationsTable />
                </div>
              </div>
            )}
          </>
        </div>
      }
    />
  );
};
export default MultiLocationOverviewModule;

const content = (
  <>
    <p>
      The Multi-Location Corporate page gives corporate level users the ability to see the network
      or compare locations on some key metrics.
    </p>
    <p>
      <b>Regions:</b> If using this feature, we will only show the data related to those stores you
      grouped by each region.
    </p>
    <p>
      <b>Division:</b> Based on your ClubReady Divisions, we will only display those stores that are
      part of the division(s) selected.
    </p>
    <p>
      <b>District:</b> Like Divisions, we will use the same Districts that you have in ClubReady. We
      will only display those stores that are part of the division(s) selected.
    </p>
    <p>
      <b>Locations:</b> You can manually select an individual location or select multiple locations.
    </p>
    <p>
      <b>Metrics:</b> These are the metrics we have available in this module. You can select one or
      many.
    </p>
    <p>
      <b>All Locations:</b> Using the dates and filters selected, we will show you the data for all
      locations selected. We also include average over the time selected.
    </p>
    <p>
      <b>Breakdown by Location:</b> This is where you can compare locations to each other. Like the
      All Locations view, we will show data over the time and filters selected as well as the
      average. It is highly suggested that when looking at comparing locations, you only select a
      single metric for ease of viewing.
    </p>
    <p>
      The default for this page is to load the following five (5) metrics; Leads, Net Revenue, New
      Members, Active Members & Attrition Rate. Once loaded you can use the “metrics” dropdown menu
      to select from other metrics. Metrics available will depend on what your brand has set.
    </p>
    <p>
      <b>Metrics Available:</b>
      <ol type="1">
        <li>
          Active Members – Based on your organization/brand settings we will display the same value
          as on both the My Dashboard modules as well as the Membership page.{" "}
        </li>
        <li>
          Appointment to Conversion - Using the LASER page data to show Appointment to Conversions
          and shown in Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Appointment.</i>
        </li>
        <li>
          Appointment to Show (From Appt) - Using the LASER page data to show Appointment to Show
          and shown in Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Appointment.</i>
        </li>
        <li>
          Appointment to Show (From Lead) - Using the LASER page data to show Appointment to Show
          and shown in Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Lead.</i>
        </li>
        <li>
          Attrition Rate – Percent of Members who have cancelled. Calculation will depend on your
          organization/brand settings.
        </li>
        <li>Cancelled Members – Number of Active members who cancelled their agreement.</li>
        <li>
          Class Conversions - Number of clients who completed their first visit then purchased a
          qualifying package. Qualifying packages are based on brand mapping.
        </li>
        <li>First Time Clients – Clients who have completed their first class/appointment.</li>
        <li>
          Forecast – The amount of revenue the store can expect to have at the current month’s end.
        </li>
        <li>
          Guest Closing %: The total number of Guest Enrollments divided by the number of Guests
          Shows.
        </li>
        <li>
          Guest Enrollments: The number of the above Guest Shows that purchased a membership or
          qualifying package. This metric will only count unique clients. If a client had multiple
          Guest Shows, they would still only show once in Guest Enrollments.
        </li>
        <li>
          Guest Shows (Total): A guest is a prospect who completed a visit. This metrics will show
          all completed visits by prospects/guests.
        </li>
        <li>
          Guest Shows (Unique): Like above but only counting the number of unique Guest Shows.{" "}
        </li>
        <li>
          Gross Revenue – Total revenue <b>BEFORE</b> refunds and returns.
        </li>
        <li>
          Lead to Appointment - Using the LASER page data to show Lead to Appointment and shown in
          Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Lead.</i>
        </li>
        <li>
          Lead to Enrollment - Using the LASER page data to show Lead to Enrollment and shown in
          Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Lead.</i>
        </li>
        <li>
          Lead to Show - Using the LASER page data to show Lead to Show and shown in Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Lead.</i>
        </li>
        <li>
          Leads/Profiles Created – Using the profile creation date to count the number of profiles
          created (leads).
        </li>
        <li>
          Net Revenue – Total revenue <b>AFTER</b> refunds and returns.
        </li>
        <li>New Members – Counting the first-time members. Does not include Rejoin members.</li>
        <li>
          Paying Members – This value will show which members have paid based on the membership
          agreement terms.
        </li>
        <li>Product Revenue – Total amount of revenue related to products.</li>
        <li>
          Prospect Appointments (Total): Any appointment booked for a prospect. A prospect is a
          client that has not yet converted to a qualifying package or membership. Qualifying
          packages are based on iKizmet mapping. Confirm with your brand contact on what is to be
          considered a qualifying package. This number will count multiple bookings of the same
          prospect.
        </li>
        <li>
          Prospect Appointments (Unique): Like above but only counting the number of unique Prospect
          Appointments
        </li>
        <li>
          Show to Conversion - Using the LASER page data to display the Show to Conversion and shown
          in Percentage (%).
          <i> This will match LASER when the Start from is set to Start from Appointment.</i>
        </li>
        <li>
          Total Enrollments – All enrollments for the time frame. This will include all memberships
          as well as any non-membership package tagged in iKizmet as a conversion.
        </li>
        <li>Total Visits – The total number of completed visits.</li>
        <li>
          Utilization – This will show the percentage of spots that were used compared to what was
          available(capacity).
        </li>
      </ol>
    </p>

    <p>
      When selecting a single metric, the columns can be sorted by clicking on the date or average.
      You can also download the data to an excel format.
    </p>
  </>
);
